
const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Connection: 'keep-alive',
};

function _getToken() {
  const token = sessionStorage.getItem('token');
  if (token) headers.Authorization = `Bearer ${token.slice(1, -1)}`;
  return token;
}


function _processResponse(result) {
  return result
    .then((res) => res.json())
    .then(async (res) => {
      let _res = res;

      /* if (!res.data) _res = { error: res.error, data: res.data };
      else if (res.data.error) _res = { error: res.data.error }; */
      if(_res.error && _res.error==='Invalid token'){
        sessionStorage.clear();
        window.location.href = "/";
      }
      return _res;
    })
    .catch((error) => {
      throw Error(error);
    });
}

function _noProcessResponse(result) {
  return result
    .then((res) => res.arrayBuffer(64))
    .then((buffer) => {
      return buffer;
    })
    .catch((error) => {
      throw Error(error);
    });
}

async function _processesRequest(request, method, params, optionalsHeaders, noProces) {
  console.log('proces:', noProces)
  _getToken();
  const response = fetch(request, {
    method,
    headers: optionalsHeaders ? { ...headers, ...optionalsHeaders } : headers,

    ...(params ? { body: JSON.stringify(params) } : {}),
  });

  const result = await noProces ? _noProcessResponse(response):_processResponse(response);
  return result;
}

async function _processesRequestFormData(request, method, params) {
  _getToken();

  const myHeaders = new Headers();
  const token = sessionStorage.getItem('token');
  if (token) myHeaders.append('Authorization', `Bearer ${token.slice(1, -1)}`);

  const formdata = new FormData();
  const keys = Object.keys(params);
  console.log(params)
  for (const k of keys) {

    console.log(typeof (params[k]))

    if (typeof (params[k]) === 'string' || typeof (params[k]) === 'number') {
      formdata.append(`${k}`, `${params[k]}`);
      console.log(params[k])
    } else if (k === 'files' && params[k] !== null) {
      //formdata.append('files', params[k]);
      const file = new Blob([params[k].target.files[0]]);
      formdata.append("files", file);
      //console.log(params[k])
      //fileIds.push(k);
    }
  }


  const response = fetch(request, {
    method,
    headers: myHeaders,
    body: formdata,
  });

  const result = await _processResponse(response);
  return result;
}




const api = (urlBase) => ({

  async get(endpoint, params = null, optionalsHeaders = null, noProces = false) {
    const result = await _processesRequest(
      `${urlBase}${endpoint}`,
      'GET',
      params,
      optionalsHeaders,
      noProces
    );
    return result;
  },
  async post(endpoint, params = null, optionalsHeaders = null) {
    console.log(params)
    const result = await _processesRequest(
      `${urlBase}${endpoint}`,
      'POST',
      params,
      optionalsHeaders
    );
    return result;
  },
  async put(endpoint, params = null, optionalsHeaders = null) {
    const result = await _processesRequest(
      `${urlBase}${endpoint}`,
      'PUT',
      params,
      optionalsHeaders
    );
    return result;
  },
  async delete(endpoint, params = null, optionalsHeaders = null) {
    const result = await _processesRequest(
      `${urlBase}${endpoint}`,
      'DELETE',
      params,
      optionalsHeaders
    );
    return result;
  },

  async postFormData(endpoint, params = null, optionalsHeaders = null) {
    const result = await _processesRequestFormData(
      `${urlBase}${endpoint}`,
      'POST',
      params,
      optionalsHeaders,
    );
    return result;
  },

});




export default api;
